export default "/react/twoGisIcon-279629c6.svg";